module.exports = __webpack_public_path__ + "img/logo.e202f378.svg";